'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _typeof = _interopDefault(require('babel-runtime/helpers/typeof'));

function EventEmitter() {
  this.events = {};
}

EventEmitter.prototype.on = function (event, listener) {
  if (!this.events[event]) {
    this.events[event] = [];
  }

  this.events[event].push(listener);
};

EventEmitter.prototype.off = function (event, listener) {
  var listeners = this.events[event];

  if ((typeof listeners === 'undefined' ? 'undefined' : _typeof(listeners)) === 'object') {
    var idx = listeners.indexOf(listener);

    if (idx > -1) {
      listeners.splice(idx, 1);
    }
  }
};

EventEmitter.prototype.emit = function (event) {
  var listeners = this.events[event];

  if ((typeof listeners === 'undefined' ? 'undefined' : _typeof(listeners)) === 'object') {
    listeners = listeners.slice();
    var length = listeners.length;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    for (var i = 0; i < length; i++) {
      listeners[i].apply(this, args);
    }
  }
};

EventEmitter.prototype.once = function (event, listener) {
  this.on(event, function eventCallback() {
    this.off(event, eventCallback);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    listener.apply(this, args);
  });
};

module.exports = EventEmitter;
